<template>
  <b-table :items="items" :fields="fields">
    <template #cell(active)="data">
      <b-form-checkbox
        v-model="data.item.active"
        disabled
        :value="true"
        :unchecked-value="false"
      >
      </b-form-checkbox>
    </template>
  </b-table>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'active', label: 'Active' }
      ],
      items: [
        { name: 'Item 1', active: true },
        { name: 'Item 2', active: false }
      ]
    };
  }
};

/* 

Using b-table with Read-Only b-switch

To render a read-only b-switch in a b-table cell, you can utilize scoped slots. 
This allows you to customize how each cell is displayed based on the data it contains.
Example Implementation

Here’s a simple example of how to implement a b-switch in a b-table:
Explanation of the Code

    b-table: This component displays the data in a tabular format.
    fields: Defines the columns of the table. In this case, we have "Name" and "Active".
    items: Contains the data to be displayed in the table.
    Scoped Slot: The #cell(active) slot allows you to customize the rendering of the "Active" column.
    b-form-checkbox: This is used to create a switch. The disabled attribute makes it read-only, preventing user interaction.

Conclusion

This setup allows you to display a read-only switch in a b-table cell, providing a 
clear visual representation of the active status without allowing edits.
muhimasri.com forum.handsontable.com

*/
</script>



